import { useSelectedSlide } from '@components/Presentation/hooks/useSelectedSlide';
import Switch from '@molecules/Switch';
import React from 'react';

function MapSound() {
  const selectedSlide = useSelectedSlide();

  return (
    <div className="flex">
      <div className="flex flex-1 text-sm flex-nowrap">
        Magic Maps sound &nbsp;
      </div>
      <Switch
        checked={!!selectedSlide.setting.mapSound}
        onChange={(e) =>
          selectedSlide.handler.updateSetting('mapSound', e.target.checked)
        }
        onClick={() => {}}
      />
    </div>
  );
}

export default MapSound;
